import Vue from 'vue';
export default Vue.extend({
    props: {
        siteDomain: { type: String, required: true },
        tableData: { type: (Array), required: true },
    },
});
